<template>
  <div class="footer" ref="footer">
    <p class="footer_wensite">
      <el-tooltip v-for="item in list" :key="item.id" :content="item.name" placement="top-start">
        <span @click="toLink(item.url)" class="wensite_name pointer">{{ item.name }}</span>
      </el-tooltip>
      <span class="pointer" v-if="showMore" @click="loadMore">更多</span>
    </p>
    <p class="footer_infor"><span class="pointer" @click="onLink" style="margin-right: 20px;">网站备案号 浙ICP备15001306号-3</span><span>技术支持 | 杭州微校互联科技有限公司</span></p>
  </div>
</template>

<script>
export default {
  name: '',
  components: {},
  data () {
    return {
      list: [],
      showMore: false
    }
  },
  created () {
  },
  mounted () {
    this.loadData()
    this.$nextTick(() => {
      this.$emit('footerHeight', this.$refs.footer.offsetHeight)
    })
  },
  computed: {},
  methods: {
    loadData () {
      this.$axios.websiteList().then(res => {
        if (res) {
          let list = []
          let length = 0
          res.data.data.forEach(item => {
            if (length < 170) {
              length += item.name.length
              list.push(item)
            } else {
              this.showMore = true
            }
          })
          this.list = list
        }
      })
    },
    onLink () {
      window.location.href = 'https://beian.miit.gov.cn'
    },
    toLink (url) {
      window.location.href = url
    },
    loadMore () {
      this.$router.push({
        path: '/website'
      })
    }
  },
  watch: {}
}
</script>

<style scoped>
  .footer {width: 1000px;height: 100%;margin: 0 auto;display: flex;flex-direction: column;justify-content: center; /*align-item: center;*/}
  .footer .footer_infor {text-align: center;font-size:12px;color: #FFFFFF;}
  .footer_wensite {text-align: center;}
  .footer_wensite span {display: inline-block;text-align: left;font-size: 12px;color: #BBBBBB;line-height: 12px;margin-bottom: 15px;max-width: 240px;margin-right: 10px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;}
</style>



// WEBPACK FOOTER //
// src/components/footer/footer.vue